export const createPrices = ({
  lower,
  higher,
  displayLowest = false
}: {
  lower: number | null
  higher: number | null
  displayLowest?: boolean
}) => {
  if (lower === 0) {
    lower = null
  }
  if (higher === 0) {
    higher = null
  }
  if (lower === null && higher !== null) {
    lower = higher
  }
  if (lower !== null && higher === null) {
    higher = lower
  }
  if (displayLowest) {
    higher = lower
  }
  return {
    lower,
    higher
  }
}
